"use strict";

function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap)
    var r = new WeakMap(),
      n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = { __proto__: null, default: e };
    if (null === e || ("object" != typeof e && "function" != typeof e))
      return f;
    if ((o = t ? n : r)) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e)
      "default" !== t &&
        {}.hasOwnProperty.call(e, t) &&
        ((i =
          (o = Object.defineProperty) &&
          Object.getOwnPropertyDescriptor(e, t)) &&
        (i.get || i.set)
          ? o(f, t, i)
          : (f[t] = e[t]));
    return f;
  })(e, t);
}
window.neptune.variant = {
  storage: {
    nextVariant: {},
  },
  kitchenPDP: {
    changeSelected: function (element, colour, rgb) {
      document.querySelectorAll(".finish-item").forEach((e) => {
        e.removeAttribute("data-selected");
      });
      element.setAttribute("data-selected", true);
      const selectElement = document.querySelector(
        'select[name="options[paint]"]',
      );
      const paintElement = document.querySelector(".js-paint-config-button");
      const elementInnerText = document.querySelector(".js-paint-config-text");
      const selectedFinish = document.querySelector(
        ".current-config-selection",
      );

      selectedFinish.innerHTML = `<a id="paint-colour" class="paint-config-button js-paint-config-button" style="--paint-colour: rgb(${rgb});" onclick="window.neptune.variant.kitchenPDP.toggleModal()">
    <span class="paint-config-button__swatch"></span>

    <span class="paint-config-button__content">
     
      <span class="paint-config-button__rgb js-paint-config-text">${colour}</span>
    </span>
  </a>`;

      paintElement.setAttribute("style", `--paint-colour: rgb(${rgb});`);
      elementInnerText.innerHTML = colour;

      if (selectElement) {
        for (const option of selectElement.options) {
          if (option.text.trim().toUpperCase() == colour.trim().toUpperCase()) {
            selectElement.value = option.value;
            console.log(option, selectElement.value);
          }
        }

        selectElement.dispatchEvent(new Event("change"));
      }

      if (window.matchMedia("(max-width:1024px)").matches) {
        var i = 0;
        document
          .querySelectorAll(".js-media-wrapper[data-media-id]")
          .forEach((e) => {
            if (
              e.dataset.mediaId == neptune.variant.getVariant().featuredMediaId
            ) {
              window.neptune.flickity.carousels[0].select(i);
            }
            i++;
          });
      }
    },
    toggleModal: function () {
      var element = document.getElementById("config-flyout");
      document
        .getElementsByClassName("configurable-product-overlay")[0]
        .classList.toggle("is-active");
      document
        .getElementsByClassName("configurable-product-overlay__inner")[0]
        .classList.toggle("is-visible");
      element.classList.toggle("is-visible");

      document.querySelector(".accordion-tabs").innerHTML =
        `<span>Select your colour</span>
      
      <button class="modal-close" type="button" onclick="window.neptune.variant.kitchenPDP.toggleModal()" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" focusable="false">
  <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
    <path d="M10.714 1.286l-9.428 9.428M1.286 1.286l9.428 9.428" stroke-width=".85714"></path>
  </g>
</svg>
        </button>
      
      
      `;
      document.querySelector(".accordion-content.tabs-only").innerHTML = "";

      JSON.parse(window.paintConfig).forEach((e) => {
        var finishgroup = `<div class="finish-group"> 
                <h5 class="type-heading-5 bordered spacing-left">
                 ${e.name}
                </h5>
                <div class="finish-items__wrapper">`;

        var finishes = ``;

        e.finishColors.forEach((r) => {
          finishes += `
                  <div class="finish-item" style="cursor:pointer" onclick="window.neptune.variant.kitchenPDP.changeSelected(this,'${r.name}','${r.swatchRGB}')">
                        <div class="finish-item-column">
                        <span class="finish-item-thumb" style="background-color:rgb(${r.swatchRGB});"></span>
                        </div>
                        <div class="finish-item-name type-body-small tl fw5" data-finish-id="905">
                         ${r.name}
                        </div>
                      </div>
                  `;
        });

        finishgroup += finishes + `</div></div>`;
        document.querySelector(".accordion-content.tabs-only").innerHTML +=
          finishgroup;
      });
    },
    init: function (paint) {
      if (window.paintConfig.length == 0) {
        return;
      }
      const paintElement = document.querySelector(".js-paint-config-button");
      var paintLabel = document.querySelector(".js-paint-config-text");
      console.log(222);
      if (window.location.href.indexOf("variant=") == -1) {
        JSON.parse(window.paintConfig).forEach((e) => {
          e.finishColors.forEach((b) => {
            if (paint.toUpperCase() == b.name.toUpperCase()) {
              paintLabel.innerHTML = b.name;
              paintElement.setAttribute(
                "style",
                `--paint-colour: rgb(${b.swatchRGB});`,
              );
            }
          });
        });
      } else {
        var selectedPaint = window.neptune.variant.getVariant().option1;
        JSON.parse(window.paintConfig).forEach((e) => {
          e.finishColors.forEach((b) => {
            if (selectedPaint.toUpperCase() == b.name.toUpperCase()) {
              paintLabel.innerHTML = b.name;
              paintElement.setAttribute(
                "style",
                `--paint-colour: rgb(${b.swatchRGB});`,
              );
            }
          });
        });
      }
    },
    triggered: false,
  },
  getVariant: function () {
    var variant = shopify_product[0].id;
    if (window.location.href.indexOf("variant=") != -1) {
      variant = window.location.href.split("variant=")[1];
      variant = variant.indexOf("&") != -1 ? variant.split("&")[0] : variant;
    }

    return shopify_product.filter((e) => e.id == variant)[0];
  },
  getVariantUrl: function () {
    var variantId = "";
    if (window.location.href.indexOf("variant=") != -1) {
      var s = window.location.href.split("variant=")[1];
      s = s.indexOf("&") != -1 ? s.split("&")[0] : s;
      var variantId = "?variant=" + s;
    }

    return (
      "https://" +
      window.location.hostname +
      window.location.pathname +
      variantId
    );
  },
  emailAvailable: {
    open: function () {
      var form = document.querySelector("keec-modal[data-email-available]");

      if (form != null) {
        form.open();
      }
    },
    post: function (event) {
      event.preventDefault();
      window.neptune.clarity("Email When Available");
      var button = document.querySelector(".js-email-available-btn");
      var variant = neptune.variant.getVariant();

      var emailElement = document.querySelector(".js-email-available-email");
      var newsletterElement = document.querySelector(
        ".js-email-available-newsletter",
      );
      var responseMsg = document.querySelector(".js-email-available-response");
      var modal = document.querySelector(
        "keec-modal[data-email-available] .keec-modal",
      );
      var mediaImg = document.querySelector(".js-media-wrapper img");
      button?.classList.add("bttn--processing");

      if (variant.image_url.toLowerCase().indexOf("no-image") == -1) {
        var path = ``;
        if (
          variant.image_url.toLowerCase().indexOf("http://") == -1 ||
          variant.image_url.toLowerCase().indexOf("https://") == -1
        ) {
          path = `https:`;
        }
        variant.imgsrc = path + variant.image_url;
      } else {
        if (mediaImg != null && mediaImg.dataset.srcset != null) {
          var x = document
            .querySelector(".js-media-wrapper img")
            .dataset.srcset.split(",");
          variant.imgsrc = x[x.length - 1].trim();

          if (variant.imgsrc.indexOf(window.location.hostname) == -1) {
            variant.imgsrc = window.location.hostname + variant.imgsrc;
          }
          if (variant.imgsrc.indexOf("http") == -1) {
            variant.imgsrc = "https:" + variant.imgsrc;
          }
        }
      }

      variant.sku = variant.articleId;
      delete variant["config"];
      delete variant["techDetails"];
      delete variant["designNotesObject"];
      delete variant["careObject"];
      delete variant["template_suffix"];
      delete variant["depth"];
      delete variant["height"];
      delete variant["width"];
      delete variant["seat_depth"];
      delete variant["seat_height"];
      delete variant["seat_width"];
      delete variant["designNotes"];
      delete variant["default_cylindo_id"];
      delete variant["optionNames"];
      delete variant["option1"];
      delete variant["option2"];
      delete variant["option3"];

      var obj = {
        dateTimePosted: new Date()
          .toISOString()
          .replace("T", " ")
          .split(".")[0],
        variant: variant || {},
        email: emailElement?.value || "",
        newsletter: newsletterElement?.value == "on" || false,
        productId: meta.product.id,
        productTitle: document.querySelector("h1").innerText,
        url: window.neptune.variant.getVariantUrl(),
      };

      var settings = {
        method: "POST",
        accept: "application/json",
        "content-type": "application/json",
        body: JSON.stringify(obj),
      };

      try {
        fetch(
          window.neptune.getAzureFunctionEnv() + "/api/HttpEmailAvailableAsync",
          settings,
        )
          .then((c) => c.json())
          .then((b) => {
            button?.classList.remove("bttn--processing");
            if (b.Key.toLowerCase() == "success") {
              modal.classList.add("keec-modal--success");
            } else {
              if (b.Value.toLowerCase().indexOf("already exists") != -1) {
                responseMsg.innerHTML = responseMsg.dataset.errorExists;
              } else {
                responseMsg.innerHTML = b.Value;
              }
            }
          });
      } catch (ex) {
        responseMsg.innerHTML = ex;
        button?.classList.remove("bttn--processing");
      }
    },
  },

  reviews: {
    hidedefault: function () {
      var excludeterms = [
        "variant: default",
        "Variant: 0 paint service",
        "Variant: 1 paint service",
        "Variant: 2 paint service",
      ];
      document.querySelectorAll(".kl_reviews__review__variant").forEach((e) => {
        excludeterms.forEach((r) => {
          if (e.innerHTML.toLowerCase().indexOf(r.toLowerCase()) != -1) {
            e.classList.add("hide");
            console.log("Hiding variant option");
          }
        });
      });
    },
  },
  update: async function (t) {
    console.log("variant - update function called");
    var variant = this.getVariant();
    const productFormItem = document.querySelector(".js-product-form-item");
    const addToCart = document.querySelector(".js-add-to-cart");
    const addToCartBtn = document.querySelector("button.js-add-to-cart");
    var description = document.querySelector(".js-product-description");
    var designNotes = document.getElementById("design-notes");
    var articleId = document.getElementById("current-article-id");
    var technicalDetails = document.querySelector(".technical-details");
    var careNeedToKnows = document.querySelector(
      ".js-care_need_to_knows .accordion__text",
    );
    var emailAvailable = document.querySelector(".product-form__back-in-stock");
    var klaviyoBackInStock = document.querySelector(
      "#klaviyo-bis-button-container",
    );
    var accordionPanels = document.querySelectorAll(".js-accordion-panel");
    var storeAvailabilityBtn = document.querySelector(
      "[data-store-availability-drawer-trigger]",
    );
    var stickyCurrentPrice = document.querySelector(
      ".product__sticky-atc-price .js-product-price-value",
    );
    var stickyComparePrice = document.querySelector(
      ".product__sticky-atc-price [data-compare-price]",
    );
    const clearpayElement = document.querySelector(".js-payment-clearpay");
    const klaviyoElement = document.querySelector(".js-payment-klarna");
    const messaging = document.querySelector("square-placement");
    var readmore = document.querySelector(".js-read-more");
    var availabilityLineString = document.querySelector(
      ".availability-visible-string",
    );
    const availElement = document.querySelector(".availability-info .message");
    const qtybtns = document.querySelector(".js-product-quantity");

    var reviewscontainer = document.querySelector(".kl_reviews__filters");
    var storeAvailFlyout = document.querySelector(".store-availability-flyout");
    var storeAvailDraw = document.querySelector("store-availability-drawer");
    var klarnaPlacement = document.querySelector("klarna-placement");

    if (
      shopify_product
        .map((e) => e.option1)[0]
        .toLowerCase()
        .indexOf("default") != -1 ||
      shopify_product
        .map((e) => e.option1)[0]
        .toLowerCase()
        .indexOf("paint service") != -1
    ) {
      if (reviewscontainer == null) {
        var q = setInterval(function () {
          if (document.querySelector(".kl_reviews__filters") != null) {
            reviewscontainer = document.querySelector(".kl_reviews__filters");
            window.neptune.variant.reviews.hidedefault();
            clearInterval(q);
          }
        }, 500);
      } else {
        window.neptune.variant.reviews.hidedefault();
      }
    }

    if (storeAvailabilityBtn != null) {
      storeAvailabilityBtn.addEventListener("click", (e) => {
        storeAvailFlyout.classList.toggle("active");
        storeAvailDraw
          .querySelector(".drawer-overlay__inner")
          .classList.remove("hide");
        window.neptune.clarity("store_availability");

        window.dataLayer.push({
          event: "store_availability_click",
          eventModel: {
            mastercode: window.neptune.variant.getVariant().mastercode,
          },
        });

        if (
          storeAvailFlyout.mastercode !=
          window.neptune.variant.getVariant().mastercode
        ) {
          storeAvailDraw.fetchStoreData(false, true);
        } else {
          storeAvailDraw.fetchStoreData(true, true);
        }
      });
    }

    if (addToCart != null) {
      addToCart.addEventListener("click", (e) => {
        e.stopImmediatePropagation();

        if (e.currentTarget.getAttribute("data-cpm-disabled") != null) {
          e.preventDefault();
          try {
            document.querySelector("ec-cpm-status").modalEl.open();
          } catch (e) {
            console.log(e);
          }
          return false;
        }

        if (addToCartBtn.getAttribute("disabled") != null) {
          e.preventDefault();
          return false;
        }

        window.neptune.clarity("add_to_cart_anchor_click");
        e.currentTarget.classList.add("bttn--loading");
        var _this = e.currentTarget;

        var hasrule =
          window["AVADA_ORDER_LIMIT_HELPER"] != null &&
          AVADA_ORDER_LIMIT_HELPER.getRulesByVariantId(
            window.neptune.variant.getVariant().id,
          );

        console.log("rules:", hasrule);

        if (hasrule.length > 0) {
          console.log("rule try");

          const qtyToAdd = Math.abs(
            Number(document.querySelector('input[name="quantity"]').value || 1),
          );

          // Current cart
          fetch("/cart.js")
            .then((r) => r.json())
            .then((cart) => {
              const cartItem = cart.items.find(
                (item) => item.variant_id == variant.id,
              );
              const totalQty = (cartItem?.quantity || 0) + qtyToAdd;

              const result = AVADA_ORDER_LIMIT_HELPER.evaluateVariantLimit({
                variantId: variant.id,
                quantity: totalQty,
              });

              if (result.invalid == false) {
                window.Shopify.theme.publicMethods.addItem(
                  document.querySelector('*[id*="product_form_"]'),
                );
              } else {
                _this.classList.remove("bttn--loading");
                document.querySelector(
                  ".Avada-OrderLimit__ErrorMessage-Product",
                ).innerHTML = result.message.text;
                console.log(result);
              }
            });
        } else {
          window.Shopify.theme.publicMethods.addItem(
            document.querySelector('*[id*="product_form_"]'),
          );
        }
      });
    }

    accordionPanels.forEach((e) => {
      if (e.querySelector(".accordion__text").innerHTML.trim().length > 100) {
        e.classList.remove("hide");
      } else {
        e.classList.add("hide");
      }
    });

    if (emailAvailable != null && window.Shopify.locale.toUpperCase() == "EN") {
      if (
        variant.availability.toLowerCase() != "in stock" &&
        variant.availability.toLowerCase() != "available now" &&
        shopify_product[0].optionNames.filter((e) => e == "fabric").length ==
          0 &&
        shopify_product[0].optionNames.filter((e) => e == "paint service")
          .length == 0 &&
        shopify_product[0].viewInStore != true
      ) {
        emailAvailable.style.display = "block";
      } else if (window.location.href.indexOf("preview_mode") != -1) {
        emailAvailable.style.display = "block";
      } else {
        emailAvailable.style.display = "none";
      }
    }

    const isButtonDisabled = addToCartBtn?.getAttribute("disabled") != null;
    const isOutOfStock =
      variant.inventory.available < 1 && variant.inventory.policy === "deny";

    if (isOutOfStock) {
      qtybtns?.classList.add("hide");
    } else {
      qtybtns?.classList.remove("hide");
    }

    if (isButtonDisabled || isOutOfStock) {
      addToCart?.setAttribute("aria-disabled", true);
    } else {
      addToCart?.removeAttribute("aria-disabled");
    }

    if (stickyCurrentPrice != null) {
      stickyCurrentPrice.innerHTML = variant.price;
    }

    var compare_at = Math.abs(variant.compare_at_price.substr(1));
    if (stickyComparePrice != null) {
      if (compare_at > 0) {
        stickyComparePrice.classList.remove("hide");
        stickyComparePrice.innerHTML = variant.compare_at_price;
      } else {
        stickyComparePrice.classList.add("hide");
      }
    }

    var currentPrice = Math.abs(variant.price.substr(1).replace(",", ""));

    if (clearpayElement == null) {
      var x = document.createElement("style");
      x.classList.add("js-payment-clearpay");
      x.dataset.max = 1500;
      x.dataset.min = 400;
      document.body.appendChild(x);
    }

    if (messaging != null && clearpayElement != null) {
      const clearpayMax = Math.abs(clearpayElement.dataset.max);
      const clearpayMin = Math.abs(clearpayElement.dataset.min);
      var x = document.createElement("style");

      x.innerHTML = `
      .afterpay-paragraph, .afterpay-main-text, .afterpay-main-text strong { 
      font-size:13px!important; 
      
      .afterpay-logo.brand-clearpay, .afterpay-logo.brand-clearpay svg {  width:70px;}

      }`;
      messaging?.shadowRoot?.appendChild(x);
      messaging.dataset.amount = currentPrice;
      if (
        currentPrice < clearpayMin ||
        currentPrice > clearpayMax ||
        window.Shopify.currency.active.toUpperCase() == "EUR"
      ) {
        clearpayElement.innerHTML =
          'div[id*="clearpay_on_site_messaging_payments"] { display:none;}';
      } else {
        clearpayElement.innerHTML = "";
      }
    }

    if (klarnaPlacement != null) {
      const klarnaMax = Math.abs(klaviyoElement?.dataset?.max);
      const klarnaMin = Math.abs(klaviyoElement?.dataset?.min);
      klarnaPlacement.dataset.amount = currentPrice;
      if (
        currentPrice < klarnaMin ||
        currentPrice > klarnaMax ||
        window.Shopify.currency.active.toUpperCase() == "EUR"
      ) {
        console.log("Klarna osm is hidden");
        klarnaPlacement.classList.add("hide");
        klarnaPlacement.classList.remove("active");
      } else {
        console.log("Klarna osm is visible");
        klarnaPlacement.classList.remove("hide");
        const style = document.createElement("style");
        style.innerHTML = `.legal { margin:0;} \n 
 .container { background:none; padding:0;      border: none;  text-align: left; } \n
    .osm-message:before { content:"Pay in "; display:inline; } \n
    .osm-message { font-family:'avenir-next-lt-pro'; font-size:13px; color:#1b1b1b; line-height:25px;} \n
    `;

        if (klarnaPlacement.shadowRoot != null) {
          klarnaPlacement.shadowRoot.appendChild(style);
        }

        klarnaPlacement.classList.add("active");
      }
    }

    if (articleId != null) {
      articleId.setAttribute("data-article-id", variant.articleId);
    }

    // If the product is set to use metaobjects for care and USPs
    var variantDesignNotes = variant.designNotesObject;
    if (
      (designNotes != null) &
      (variantDesignNotes != null) &
      (variantDesignNotes != "")
    ) {
      designNotes.innerHTML = variantDesignNotes;
    }
    if (careNeedToKnows != null) {
      careNeedToKnows.innerHTML = shopify_product[0].careObject;
    }

    if (
      (description != null) &
      (variant.description != null) &
      (variant.description != "")
    ) {
      if (
        htmlDecode(variant.description).length > 137 &&
        Array.from(readmore.classList).filter((e) => e.indexOf("hide") != -1)
          .length == 0
      ) {
        var startAt = 137;
        var s = htmlDecode(variant.description).substr(0, startAt);
        var lastChar = s.charAt(s.length - 1);
        if (lastChar != " ") {
          for (var i = 0; i < 1000; i++) {
            var xx = htmlDecode(variant.description).substr(0, startAt + i);
            if (xx.charAt(xx.length - 1) == " ") {
              startAt += i;
              break;
            }
          }
        }

        description.innerHTML = `${htmlDecode(variant.description).substr(0, startAt - 1)}<span class="js-elipsis">...</span><span class="hide js-readmore"> ${htmlDecode(variant.description).substr(startAt)}</span>`;
      } else {
        description.innerHTML = htmlDecode(variant.description);
      }
    }

    if (variant.viewInStore == true) {
      var css = `.product__sticky-atc { display:none!important; } .shopify-payment-button__button, .qty-availability-container, .js-product-form-controls-group button:not(.product-form__viewinstore-submit) { pointer-events:none}`;
      if (variant.availability.toUpperCase() != "AVAILABLE IN STORE") {
        //css += `.availability-info { display: none!important;}`;
      } else {
        css += `.find-a-store { display:none;}`;
      }

      productFormItem != null
        ? productFormItem.classList.add("product-form__item--viewInStore")
        : null;
      window.neptune.variant._glob.elementStyle(css, "paymentButtons001");
      addToCart != null
        ? addToCart.setAttribute("disabled", "true")
        : undefined;
    } else {
      productFormItem != null
        ? productFormItem.classList.remove("product-form__item--viewInStore")
        : null;
      addToCart != null && addToCart.getAttribute("disabled") != null
        ? addToCart.removeAttribute("disabled")
        : undefined;
      if (document.querySelectorAll(".paymentButtons001").length > 0) {
        document.querySelectorAll(".paymentButtons001").forEach((e) => {
          e.remove();
        });
      }
    }

    if (technicalDetails != null) {
      var htmlString = ``;
      technicalDetails.innerHTML = htmlString;
      if (variant.techDetails != null) {
        variant.techDetails.forEach((e) => {
          var data =
            `<li><span>` +
            e.name +
            ":</span> <span>" +
            e.value +
            (e.unit != null ? e.unit : "") +
            `</span></li>`;
          if (e.careManual == true) {
            data =
              `<li><a href="` +
              e.value +
              `" target="_blank">` +
              e.name +
              `</a></li>`;
          }
          htmlString += data;
        });
        technicalDetails.innerHTML = htmlString;
        document.querySelector(".technical-details").innerHTML = htmlString;
      }
    }

    if (availElement != null) {
      if (window.neptune?.enhanced_configuration) {
        if (window.location.href.indexOf("variant=") != -1) {
          availElement.innerHTML = variant.availability;
          availElement.parentNode.classList.remove("hide");
        }
      } else {
        if (window.options != null && window.options.paint_service() == null) {
          availElement.innerHTML = variant.availability;
        } else if (
          window.options != null &&
          window.options.paint_service() != null &&
          Object.keys(shopify_product[0].config) == 0
        ) {
          availElement.innerHTML = variant.availability;
        }
      }

      if (availabilityLineString != null) {
        var cleantext = availElement.innerHTML
          .toLowerCase()
          .replace("delivered", "")
          .replace("delivery", "")
          .trim();
        availabilityLineString.value =
          cleantext.charAt(0).toUpperCase() + cleantext.substring(1);
      }
    }

    if (typeof window.neptune.cylindo.init == "function") {
      window.neptune.cylindo.init();
    }
  },
  renewed: function () {
    document.querySelectorAll("section").forEach((e) => {
      if (e.innerHTML.toLowerCase().indexOf("neptune renewed") != -1) {
        window.scrollTo({
          top: e.offsetTop - e.clientHeight / 4,
          behavior: "smooth",
        });
      }
    });
  },
  images: {
    update: function () {
      // should not apply to single variants
      if (
        shopify_product.length == 1 &&
        window.neptune.variant.kitchenPDP.triggered == false
      ) {
        return;
      }

      // requires media to be linked at variant level to a product.
      var variant = window.neptune.variant.getVariant();
      // if (window.neptune?.enhanced_configuration && !variant) return;
      const currentIndex = shopify_product.findIndex(
        (e) => e.id == variant?.id,
      );
      var nextVariant = shopify_product[currentIndex + 1];
      window.neptune.variant.storage.nextVariant = nextVariant;
      var featuredIds = Array.from(
        new Set(shopify_product.map((e) => e.featuredMediaId)),
      );
      var start = false;
      var process = false;

      if (window.neptune.variant.kitchenPDP.triggered == true) {
        if (window.location.href.indexOf("variant=") == -1) {
          document
            .querySelectorAll(".js-product-thumbnail, .js-lightbox-nav-image")
            .forEach((e) => {
              const thisMediaId = e.getAttribute("data-media-id");

              var isLinked = shopify_product.find(
                (r) => r.featuredMediaId == thisMediaId,
              );
              if (isLinked != null) {
                e.classList.add("hidden");
              }
            });
          var i = 0;
          document.querySelectorAll(".js-media-wrapper").forEach((e) => {
            i == 0 ? e.classList.remove("hidden") : e.classList.add("hidden");
            i++;
          });
        } else {
          document
            .querySelectorAll(".js-product-thumbnail, .js-lightbox-nav-image")
            .forEach((e) => {
              const thisMediaId = e.getAttribute("data-media-id");

              var isLinked = shopify_product.find(
                (r) => r.featuredMediaId == thisMediaId,
              );

              if (
                isLinked != null &&
                window.neptune.variant.getVariant().featuredMediaId !=
                  thisMediaId
              ) {
                e.classList.add("hidden");
              } else {
                e.classList.remove("hidden");
              }
            });

          document.querySelectorAll(".js-media-wrapper").forEach((e) => {
            const thisMediaId = e.getAttribute("data-media-id");
            thisMediaId == variant.featuredMediaId
              ? e.classList.remove("hidden")
              : e.classList.add("hidden");
          });
        }

        return;
      }

      if (
        window.neptune?.enhanced_configuration == false ||
        (window.neptune?.enhanced_configuration == null &&
          window.options != null &&
          window.options.fabric_service() == null)
      ) {
        if (
          window.options.paint_service() != null &&
          window.matchMedia("(min-width:960px)").matches == true
        ) {
          if (
            neptune.configured != null &&
            neptune.configured.isInteracted == true
          ) {
            var x = document.createElement("style");
            x.innerHTML = `@media screen and (min-width: 1024px) {
              .product-thumbnails__list.cylindo-360-thumb  {
                order: -1;
                margin-bottom:12px;
              }
            }`;
            document.body.appendChild(x);
            return;
          }

          if (
            neptune.configured != null &&
            shopify_product.filter((e) => e.featuredMediaId != "").length == 0
          ) {
            return;
          }
        }

        document
          .querySelectorAll(".js-product-thumbnail, .js-lightbox-nav-image")
          .forEach((e) => {
            const thisMediaId = e.getAttribute("data-media-id");

            if (thisMediaId == variant.featuredMediaId) {
              // Start here and set visible for image for this variant.
              start = true;
              process = true;
            }

            if (
              start == true &&
              nextVariant != null &&
              nextVariant.featuredMediaId == thisMediaId &&
              process == true &&
              featuredIds.length > 1
            ) {
              // process  is running, if this media id matches the next variant in the list set false.
              process = false;
            }

            // in the loop if the process is still "true" set the image as visible.
            process == true
              ? e.classList.remove("hidden")
              : e.classList.add("hidden");
          });

        // Main preview image.
        document.querySelectorAll(".js-media-wrapper").forEach((e) => {
          const thisMediaId = e.getAttribute("data-media-id");
          thisMediaId == variant.featuredMediaId
            ? e.classList.remove("hidden")
            : e.classList.add("hidden");
        });
      } else if (window.neptune?.enhanced_configuration == true) {
        if (window.location.href.indexOf("variant=") != -1) {
          document
            .querySelector("[data-product-thumbnails]")
            .classList.add("order-last");
          document.querySelector("#cylindo-thumb-image").click();
        } else {
          document
            .querySelector("[data-product-thumbnails]")
            .classList.remove("order-last");
        }
      }

      import(flu.chunks.flickity).then(function (result) {
        var carousel = document.querySelector(".lightbox__images");
        var flkty = result.Flickity.data(carousel);
        if (flkty == null) return;
        flkty.reloadCells();
      });
    },
    setDim: function (element) {
      const mediaElements = document.querySelectorAll(
        ".js-media-wrapper, ec-cpm-cylindo",
      );
      mediaElements.forEach((e) => {
        if (e.innerHTML.indexOf("dimension") != -1) {
          e.classList.remove("hidden");
        } else {
          e.classList.add("hidden");
        }
      });
    },
  },
  _glob: {
    elementStyle: function (css, cssClass) {
      var x = document.createElement("style");
      x.innerHTML = css;
      x.setAttribute("class", cssClass);
      document.body.appendChild(x);
    },
    gotoParent: function (element) {
      var parent = document.querySelector(".js-product-breadcrumb-parent");
      if (parent != null) {
        window.location.href = parent.href + "?filter.v.m.int.is_available=1";
      }
    },
  },
};
